<template>
  <div class="wrapper-total">
    <div class="outer row no-margin">
      <div class="col">{{ $t('message.subtotal') }}</div>
      <div class="col text-right">
        {{ getNumber(subTotalNumber) }}
      </div>
    </div>
    <div class="outer row no-margin">
      <div class="col">{{ $t('message.discounts') }}</div>
      <div class="col text-right">
        {{ getNumber(discountNumber) }}
      </div>
    </div>

    <div
      v-for="(tax, index) in taxes"
      :key="index"
      class="outer row no-margin"
    >
      <div class="col">
        {{ tax.displayText }}
      </div>
      <div class="col text-right">
        {{ getNumber(tax.total) }}
      </div>
    </div>
    <div class="outer row no-margin">
      <div class="col">{{ $t('message.total') }}</div>
      <div class="col text-right">
        {{ getNumber(totalNumber) }}
      </div>
    </div>
  </div>
</template>

<script>
import totalPriceMixin from '@/mixins/pos/totalPrice'

export default {
  mixins: [totalPriceMixin],
}
</script>

<style scoped>
  .wrapper-total {
    font-size: 13px;
    color: #383D44;
    padding: 5px 0 0 0;
    border-top: solid 1px #F2F2F2;
  }
  .wrapper-total .outer {
    padding: 5px 0 4px 0;
  }
  .btn-pay {
    padding: 9px 0px 7px 0;
    font-size: 16px;
    font-weight: bold;
    border-radius: 2px;
  }

  body[device="desktop"] .btn-pay {
    padding: 12px 0px 10px 0;
    font-size: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/common/TotalPrice.vue